
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getUpdateMailDtoFormGroup() {
return new FormGroup({
    contactId: new FormControl<number | undefined>(undefined, [Validators.required]),
    contactPersonId: new FormControl<number | undefined>(undefined),
    value: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    note: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    mailtypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    standard: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    canLogin: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    id: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      